import { JobsConfigurationJob } from "modules/system/sections/plt/field-management/rings/rollout-package/configure/jobs/dtos";

import {
  CenteredBox,
  FontSizes,
  LabeledText,
  LabeledTextGroup,
  LabeledTextStyles,
  Stack,
  Text,
  useFieldArray,
  useTheme
} from "@bps/fluent-ui";

import { Commands } from "./Commands";

const labeledTextStyles: Partial<LabeledTextStyles> = {
  root: {
    gridTemplateColumns: "0.2fr 1fr",
    minHeight: 32,
    columnGap: "8px",
    alignItems: "center"
  },
  label: { fontSize: FontSizes.medium }
};

interface CommandsEditProps {
  selectedJobId?: string;
}

export const CommandsEdit: React.FC<CommandsEditProps> = ({
  selectedJobId
}) => {
  const theme = useTheme();

  const { value: jobs } = useFieldArray<JobsConfigurationJob>("jobs");

  if (!selectedJobId)
    return (
      <CenteredBox>
        <Text>Please select a job.</Text>
      </CenteredBox>
    );

  const job = jobs.find(x => x.id === selectedJobId)!;

  return (
    <Stack verticalFill tokens={{ childrenGap: theme.spacing.s1 }}>
      <Text variant="xLarge">{job.code ?? job.name}</Text>
      <Stack
        verticalFill
        tokens={{ childrenGap: theme.spacing.m }}
        styles={{
          root: {
            overflow: "auto",
            height: "100%",
            maxHeight: 600,
            maxWidth: 1250
          }
        }}
      >
        <Stack tokens={{ childrenGap: theme.spacing.l1 }}>
          <LabeledTextGroup>
            <LabeledText wrap styles={labeledTextStyles} label="Job Name">
              {job.name}
            </LabeledText>
            <LabeledText
              wrap
              styles={labeledTextStyles}
              label="Execution Frequency"
            >
              {job.executionFrequency}
            </LabeledText>
          </LabeledTextGroup>
        </Stack>
        <Commands job={job} />
      </Stack>
    </Stack>
  );
};
